import { render, staticRenderFns } from "./RuleConfiguration.vue?vue&type=template&id=19636f48"
import script from "./RuleConfiguration.vue?vue&type=script&lang=js"
export * from "./RuleConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports